import script from "./SelectionCriteria005.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionCriteria005.vue?vue&type=script&setup=true&lang=js"

import "./SelectionCriteria005.vue?vue&type=style&index=0&id=ccda7e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccda7e7c"]])

export default __exports__